<!-- Dialog pannello notifiche -->
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  styleClass="pec-notification-dialog"
  [style]="{ width: '600px', maxHeight: '80vh' }"
  (onHide)="closePanel()">

  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="header-title">
        <app-material-icon
          iconName="notifications"
          [outlined]="false"
          [size]="24"
          color="#ffffff">
        </app-material-icon>
        <span>Notifiche PEC</span>
      </div>

      <!-- Stato connessione -->
      <div class="connection-status">
        <span class="status-indicator" [style.background-color]="getConnectionStatusColor()"></span>
        <span class="status-label">{{ getConnectionStatusLabel() }}</span>
      </div>
    </div>
  </ng-template>

  <!-- Contenuto -->
  <ng-template pTemplate="content">
    <div class="notification-content">

      <!-- Nessuna ricevuta -->
      <div *ngIf="receipts.length === 0" class="empty-state">
        <app-material-icon
          iconName="inbox"
          [outlined]="true"
          [size]="64"
          color="#bdbdbd">
        </app-material-icon>
        <h3>Nessuna notifica</h3>
        <p>Non ci sono ricevute PEC da visualizzare</p>
      </div>

      <!-- Lista ricevute -->
      <p-scrollPanel *ngIf="receipts.length > 0" [style]="{ width: '100%', height: '400px' }">
        <div class="receipts-list">
          <div
            *ngFor="let receipt of receipts"
            class="receipt-card">

            <div class="receipt-icon">
              <app-material-icon
                [iconName]="getReceiptIcon(receipt.tipoRicevuta)"
                [outlined]="false"
                [size]="32"
                [color]="getReceiptIconColor(receipt.tipoRicevuta)">
              </app-material-icon>
            </div>

            <div class="receipt-content">
              <div class="receipt-header">
                <h4>{{ receipt.oggetto }}</h4>
                <p-tag
                  [value]="receipt.tipoRicevuta"
                  [severity]="getTagSeverity(receipt.tipoRicevuta)">
                </p-tag>
              </div>

              <div class="receipt-details">
                <div class="detail-row">
                  <app-material-icon
                    iconName="badge"
                    [outlined]="true"
                    [size]="18"
                    color="#757575">
                  </app-material-icon>
                  <span class="detail-label">Controllo:</span>
                  <span class="detail-value">#{{ receipt.controlloId }}</span>
                </div>

                <div class="detail-row">
                  <app-material-icon
                    iconName="person"
                    [outlined]="true"
                    [size]="18"
                    color="#757575">
                  </app-material-icon>
                  <span class="detail-label">Destinatario:</span>
                  <span class="detail-value">{{ receipt.destinatario }}</span>
                </div>

                <div class="detail-row">
                  <app-material-icon
                    iconName="schedule"
                    [outlined]="true"
                    [size]="18"
                    color="#757575">
                  </app-material-icon>
                  <span class="detail-label">Ricevuta:</span>
                  <span class="detail-value">{{ formatDate(receipt.dataRicezione) }}</span>
                </div>

                <div *ngIf="receipt.messaggio" class="receipt-message">
                  <app-material-icon
                    iconName="info"
                    [outlined]="true"
                    [size]="18"
                    color="#2196f3">
                  </app-material-icon>
                  <span>{{ receipt.messaggio }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-scrollPanel>
    </div>
  </ng-template>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Cancella Tutto"
        icon="pi pi-trash"
        class="p-button-text p-button-secondary"
        [disabled]="receipts.length === 0"
        (click)="clearAll()">
      </button>
      <button
        pButton
        type="button"
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        (click)="closePanel()">
      </button>
    </div>
  </ng-template>
</p-dialog>

